
import { Vue } from "vue-class-component";
import { imgsList } from "../../assets/homeData";
export default class CoreFunc extends Vue {
  coreData = imgsList;
}
//前两次修改后续都要提交任务回退，用于饿了么审核
